import { initExpLiteSlardar, SLARDAR_ENV } from '@byted-vcloud/exp-lite-slardar'
import { env } from './env'

const getSlardarEnv = () => {
  if (env.isDev) {
    return SLARDAR_ENV.local
  } else if (env.isBoe) {
    return SLARDAR_ENV.boe
  } else if (env.isPPE) {
    return SLARDAR_ENV.ppe
  } else if (env.isProd) {
    return SLARDAR_ENV.production
  } else if (env.isTest) {
    return SLARDAR_ENV.test
  } else {
    return SLARDAR_ENV.test
  }
}

const ignoreError = ['CheckError', 'Forbidden']

const slardarConfig = {
  pid: 'imagexlite',
  env: getSlardarEnv(),
  ignoreError,
}

export const getSlardar = () => {
  return initExpLiteSlardar(slardarConfig)
}
